import PlatformSimpleForm from './PlatformSimpleForm'

export default PlatformSimpleForm
